import type { LorsCopy } from "./translations";

const LorsStickyCta = ({ copy }: { copy: LorsCopy }) => {
  const handleClick = () => {
    const form = document.getElementById("lors-form");
    if (form) {
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-3 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"
      style={{ borderColor: "hsl(199 21% 86%)", paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <button
        onClick={handleClick}
        className="w-full py-3.5 rounded-md font-semibold text-base shadow-lg active:scale-[0.99] transition-transform"
        style={{
          backgroundColor: "hsl(34 23% 72%)",
          color: "hsl(210 24% 20%)",
          fontFamily: "'Montserrat', system-ui, sans-serif",
        }}
      >
        {copy.formSubmit}
      </button>
    </div>
  );
};

export default LorsStickyCta;
